import { GET_ORGCHART_STAFF } from 'actions/Orgchart/action_types';
import { REDUCER_ACTION } from './types';
import { IOrgChartStaff } from '../../interfaces/orgchart';

export const updateOrgChartStaffInfo = (
  staffInfo: Partial<IOrgChartStaff>
): REDUCER_ACTION => {
  return {
    type: GET_ORGCHART_STAFF,
    staff: staffInfo,
  };
};
